function esDiagnosticoFirebaseUrl() {
  try {
    return typeof window !== 'undefined' && window.location?.search?.includes('fbdiag=1');
  } catch (_e) {
    return false;
  }
}

export function firebaseErrorHintEs(err) {
  const code = err?.code || '';
  const dev = esDiagnosticoFirebaseUrl();

  const hintsUsuario = {
    'auth/unauthorized-domain':
      'Este sitio no está autorizado para iniciar sesión. Si sos quien administra la app, revisá los dominios permitidos en Firebase.',
    'auth/operation-not-allowed':
      'El inicio con email y contraseña no está activado. Pedile a quien administra el proyecto que lo habilite en Firebase.',
    'auth/email-already-in-use': 'Ese correo ya está registrado. Iniciá sesión o usá otro email.',
    'auth/invalid-email': 'El correo no tiene un formato válido.',
    'auth/weak-password': 'La contraseña debe tener al menos 6 caracteres.',
    'auth/invalid-credential':
      'Correo o contraseña incorrectos, o no existe una cuenta con email/contraseña para ese correo. Probá “Olvidé mi contraseña” o creá cuenta.',
    'auth/user-not-found': 'No hay cuenta con ese correo.',
    'auth/wrong-password': 'Contraseña incorrecta.',
    'auth/too-many-requests': 'Demasiados intentos. Esperá unos minutos.',
    'permission-denied':
      'No tenemos permiso para guardar. Cerrá sesión y volvé a entrar, o probá más tarde.',
    unavailable:
      'No pudimos conectar. Revisá WiFi o datos y probá de nuevo.',
    'failed-precondition':
      'Algo falló al guardar. Recargá la página o probá otro navegador.',
    'deadline-exceeded': 'La solicitud tardó demasiado. Probá de nuevo con mejor señal.',
  };

  const hintsDev = {
    'auth/unauthorized-domain':
      'Agregá el dominio en Firebase → Authentication → Configuración → Dominios autorizados (ej. localhost, 127.0.0.1 y tu dominio al publicar).',
    'auth/operation-not-allowed':
      'Activá "Correo electrónico/contraseña" en Firebase → Authentication → Método de acceso.',
    'auth/email-already-in-use': 'Ese correo ya está registrado. Iniciá sesión o usá otro email.',
    'auth/invalid-email': 'El correo no tiene un formato válido.',
    'auth/weak-password': 'La contraseña debe tener al menos 6 caracteres.',
    'auth/invalid-credential':
      'Correo o contraseña incorrectos, o no existe una cuenta con email/contraseña para ese correo. Probá “Olvidé mi contraseña” o creá cuenta.',
    'auth/user-not-found': 'No hay cuenta con ese correo.',
    'auth/wrong-password': 'Contraseña incorrecta.',
    'auth/too-many-requests': 'Demasiados intentos. Esperá unos minutos.',
    'permission-denied':
      'Firestore rechazó la operación. Desplegá las reglas del proyecto (archivo firestore.rules) en Firebase Console o revisá que el usuario pueda escribir en usuarios/{suUid}.',
    unavailable:
      'No se pudo conectar con la base de datos. Probá abrir la misma página agregando ?fbdiag=1 al final de la URL (diagnóstico). Revisá la API key en Google Cloud y que Firestore esté creado en Firebase Console.',
    'failed-precondition':
      'Conflicto de configuración de Firestore. Probá recargar la página o otro navegador.',
    'deadline-exceeded': 'La solicitud tardó demasiado. Probá de nuevo con mejor señal.',
  };

  const table = dev ? hintsDev : hintsUsuario;
  return table[code] || null;
}
